import { Component, Input, NgZone, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { ItemAccessDialogComponent } from 'src/app/dialogs/item/item-access-dialog/item-access-dialog.component';
import { CNLabo } from 'src/app/models/cnlabo';
import { PatientService } from 'src/app/services/patient.service';
import { RecordContainerMode } from '../../record/record-container/record-container.component';

declare var Ext: any;

@ManageType('LaboRowComponent')
@Component({
  selector: 'app-labo-row',
  templateUrl: './labo-row.component.html',
  styleUrls: ['./labo-row.component.scss']
})
export class LaboRowComponent implements OnInit {

  @Input() record: CNLabo;
  @Input() mode: RecordContainerMode = RecordContainerMode.compact;
  expanded = false;

  constructor(private patient: PatientService, private dialog: MatDialog, private ngZone: NgZone) { }

  ngOnInit(): void {
  }

  get date() {
    return moment(this.record.date).format('DD/MM/YYYY');
  }

  openAccess() {
    const dialogRef = this.dialog.open(ItemAccessDialogComponent, {
      data: {
        item: this.record
      },
      maxWidth: '60%',
      minWidth: '480px'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
}
